import axios from "axios";

export function loadAlbums({ commit }) {
  return axios.get("api/Album").then(response => {
    commit("saveAlbums", response.data);
  });
}
